import { render, staticRenderFns } from "./cpc.vue?vue&type=template&id=15a437c3&scoped=true&"
import script from "./cpc.vue?vue&type=script&lang=js&"
export * from "./cpc.vue?vue&type=script&lang=js&"
import style0 from "./cpc.vue?vue&type=style&index=0&id=15a437c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a437c3",
  null
  
)

export default component.exports